import { Typography } from "@hellocarbo/lasagne";
import { cn } from "@hellocarbo/lasagne/utils";
import { Trans, useTranslation } from "react-i18next";

import sbtiIllustrationEn from "@/assets/en/trajectory-illustrations/sbti.png";
import sbtiIllustrationFr from "@/assets/fr/trajectory-illustrations/sbti.png";
import PedagogicLink from "@/components/PedagogicLink";

function SBTiTargets({ fullWidth = false }: { fullWidth?: boolean }) {
  const { t, i18n } = useTranslation(["trajectory"]);

  return (
    <div
      className={cn(
        "gap-lg flex flex-col",
        !fullWidth && "xl:grid xl:grid-cols-2"
      )}
    >
      <img
        src={i18n.language === "fr" ? sbtiIllustrationFr : sbtiIllustrationEn}
        alt={t("trajectory:pedagogy.targets.sbti.illustrationAltText")}
        className="w-full"
      />
      <div className="gap-sm flex flex-col">
        <Typography step="-1">
          <Trans
            t={t}
            i18nKey="trajectory:pedagogy.targets.sbti.text"
            components={{
              1: <br />,
            }}
          />
        </Typography>
        <Typography step="-1">
          <Trans
            t={t}
            i18nKey="trajectory:pedagogy.targets.sbti.text2"
            components={{
              1: <br />,
            }}
          />
        </Typography>
        <div>
          <PedagogicLink
            text={t("trajectory:pedagogy.targets.helpCenterText")}
            href="https://hellocarbo-25361575.hs-sites-eu1.com/knowledge/carbo-objectifs-de-reduction#obj-entreprises"
          />
        </div>
      </div>
    </div>
  );
}

export default SBTiTargets;
